<template>
    <div class="slider-wrapper">
        <div class="slides">
            <Slide
                v-for="(slide, index) in slideList"
                :key="slide.id"
                :isActive="isActive(index)"
                :slide="slide">
            </Slide>
        </div>
        <div class="mobile-slides" :style="{backgroundImage: `url(${bannerImg})`}"></div>
    </div>
</template>

<script>
import Slide from './Slide.vue';

export default {
    name: 'Slider',
    props: [ 'slideList', 'bannerImg' ],
    components: {
        Slide
    },
    data: function() {
        return {
            activeIndex: 0
        }
    },
    methods: {
        isActive: function(index) {
            if (index == this.activeIndex) {
                return true;
            }
            return false;
        },
        changeSlide: function(index) {
            this.activeIndex = index;
        }
    },
    mounted: function() {
        let component = this;

        function carousel() {
            component.activeIndex ++;
            if (component.activeIndex >= component.slideList.length) {
                component.activeIndex = 0;
            }    
            setTimeout(carousel, 10000);
        }

        setTimeout(carousel, 10000);
    }
}   
</script>

<style scoped lang="scss">

    .slider-wrapper {
        position: absolute;    
        width: 100%;
        height: 100vh;
        min-height: 550px;
        overflow: hidden;

        & .slides {
            position: absolute;
            width: 100%;
            height: 100%;

            @media all and (max-width: 760px) {
                display: none;
            }
        }

        & .mobile-slides {
            display: none;
            position: relative;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            opacity: 0.8;
            &::after {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                background-color: #50aadb;
                opacity: 0.8;
                z-index: 3;
            }

            @media all and (max-width: 760px) {
                display: block
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Slider.vue?97951070